import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-modal-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './modal-spinner.html',
  styles: `
    .scrim {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.18);
      z-index: 22;
    }

    .sheet {
      position: fixed;
      right: 10%;
      bottom: 35%;
      left: 10%;
      top: 20%;
      z-index: 23;
      max-width: 54rem;
      margin: 0 auto;
      padding: 2rem 1rem calc(1.2rem + env(safe-area-inset-bottom));
      border-radius: 1.25rem;
      background: var(--gradient-primary, darkgray);
      color:var(--color-background, white);
      opacity:.5;
      box-shadow: 0 -1rem 3rem rgba(0, 0, 0, 0.16);
      display:flex; flex-direction:column;
      align-items:center; justify-content:center;
      font-size:24px;
      font-weight: bold;
      text-align:center;
    }
  `,
})
export class ModalSpinner {
  open = input(true);
  label = input('Loading...');
}
